import {motion,useReducedMotion} from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import DecryptedText from './DecryptedText';
import ParticleText from './ParticleText';
import SocialIcon from './SocialIcon';
import '../socialRowFix.css';

const {FiCheck,FiShare2}=FiIcons;

const bioText=[
  'AI music,creator gear,Amazon finds,and lifetime software deals.',
  'In collab with 8848 Stories/Toolaro.',
  'Every link supports the journey.'
].join('\n');

export default function ProfileBlock({profile,socials}) {
  const reduceMotion=useReducedMotion();
  const duplicateCounts={};

  const share=async ()=> {
    const payload={
      title: 'Dadda Cool',
      text: 'Dadda Cool — Links from the future',
      url: window.location.href
    };

    try {
      if (navigator.share) {
        await navigator.share(payload);
      } else {
        await navigator.clipboard.writeText(window.location.href);
      }
    } catch {
      // Visitors can cancel the native share dialog.
    }
  };

  return (
    <motion.section
      className="profile-block"
      initial={reduceMotion ? false : {opacity: 0,y: 6}}
      animate={{opacity: 1,y: 0}}
      transition={{duration: 0.24,ease: 'easeOut'}}
    >
      <div className="profile-heading">
        <div className="avatar-ring">
          <img
            src={profile.image_url}
            alt={`${profile.display_name} profile`}
            fetchPriority="high"
          />
        </div>
        <button
          type="button"
          className="profile-share"
          onClick={share}
          aria-label="Share Dadda Cool profile"
          title="Share profile"
        >
          <SafeIcon icon={FiShare2} />
        </button>
      </div>

      <h1>
        <ParticleText
          text="DADDA COOL"
          particleSize={1.35}
          density={3}
          color="#ffffff"
          highlightColor="#64e8ce"
          scatter={42}
          gatherDuration={850}
          stagger={180}
          pointerRepel={12}
          repelRadius={42}
          idleDrift={0.25}
          trigger="hover"
          fontSize={25}
          fontWeight={800}
          fontFamily="Space Grotesk"
          glow
          className="profile-particle-title"
        />
        <span className="verified" aria-label="Verified">
          <SafeIcon icon={FiCheck} />
        </span>
      </h1>

      <p className="profile-bio profile-bio-expanded">
        <DecryptedText
          text={bioText}
          speed={55}
          maxIterations={48}
          sequential
          revealDirection="center"
          characters="ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789@#$%&*+"
          animateOn="inViewHover"
          className="bio-decrypted-character"
          encryptedClassName="bio-encrypted-character"
          parentClassName="profile-decrypted-bio"
        />
      </p>

      <div
        className="social-row official-social-row"
        aria-label="Dadda Cool social and music channels"
      >
        {socials
          .filter(
            (social)=> String(social.active).toUpperCase()!=='FALSE'
          )
          .map((social)=> {
            const variant=duplicateCounts[social.platform] || 0;
            duplicateCounts[social.platform]=variant + 1;
            const platform=social.label || social.platform.replaceAll('_',' ');

            return (
              <motion.a
                key={social.id}
                href={social.url}
                target={social.url?.startsWith('mailto:') ? undefined : '_blank'}
                rel="noreferrer"
                aria-label={`${platform} channel`}
                title={platform}
                whileTap={reduceMotion ? undefined : {scale: 0.92}}
              >
                <SocialIcon
                  platform={social.platform}
                  variant={variant}
                  className="social-icon"
                />
              </motion.a>
            );
          })}
      </div>
    </motion.section>
  );
}